"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationDashboardReportingTypeEnum = void 0;
var OrganizationDashboardReportingTypeEnum;
(function (OrganizationDashboardReportingTypeEnum) {
    OrganizationDashboardReportingTypeEnum["Entry"] = "Entry";
    OrganizationDashboardReportingTypeEnum["Standard"] = "Standard";
    OrganizationDashboardReportingTypeEnum["Enterprise"] = "Enterprise";
})(OrganizationDashboardReportingTypeEnum = exports.OrganizationDashboardReportingTypeEnum || (exports.OrganizationDashboardReportingTypeEnum = {}));
